// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import CommonLayout from './components/CommonLayout';


export default function ErrorPage() {
    const { t } = useTranslation();
    return (
        <CommonLayout hideBreadcrumb={true} pageTitle={[t('error')]}>
            <>
            </>
        </CommonLayout>
    );
}
